const numeric = require("numeric");

function createPca(numPoints, scene) {
  console.log("create demo PCA");
  const pointsArray = generatePointsArray(numPoints, scene);
  if (scene) drawPcaObj(pointsArray, scene);
  const pcaObj = getPcaObj(pointsArray);
  if (scene) drawPcaObj(pcaObj, scene);
  return pcaObj;
}

function generatePointsArray(numPoints, scene) {
  const pointsArray = []; // store as THREE.Vector3
  // Generate points
  for (let i = 0; i < numPoints; i++) {
    // Create an elongated cluster tilted in space
    const t = Math.random() * 10;

    // transform to world using basis matrix
    const point = new THREE.Vector3(
      t * 0.8 + (Math.random() - 0.5) * 0.5,
      t * 0.3 + (Math.random() - 0.5) * 0.3,
      t * 0.5 + (Math.random() - 0.5) * 0.4,
    );
    pointsArray.push(point);
  }

  return pointsArray;
}

function drawPointsArray(pointsArray, scene, color) {
  let numPoints = pointsArray.length;
  const pointGeometry = new THREE.BufferGeometry();
  const positions = new Float32Array(numPoints * 3);
  for (let i = 0; i < numPoints; i++) {
    const p = pointsArray[i];
    positions[i * 3] = p.x;
    positions[i * 3 + 1] = p.y;
    positions[i * 3 + 2] = p.z;
  }
  pointGeometry.setAttribute(
    "position",
    new THREE.BufferAttribute(positions, 3),
  );
  const pointMaterial = new THREE.PointsMaterial({
    size: 0.3,
    color: color ? color : 0xff0000,
    opacity: 1.0,
    transparent: true,
  });
  const pointsCloud = new THREE.Points(pointGeometry, pointMaterial);
  scene.add(pointsCloud);
}

function getPcaObj(pointsArray) {
  // --- PCA Implementation using numeric.js ---
  // Convert points to array of [x,y,z] arrays
  const data = pointsArray.map((p) => [p.x, p.y, p.z]);
  const n = data.length;

  // 1. Compute mean
  const mean = [0, 0, 0];
  for (let i = 0; i < n; i++) {
    mean[0] += data[i][0];
    mean[1] += data[i][1];
    mean[2] += data[i][2];
  }
  mean[0] /= n;
  mean[1] /= n;
  mean[2] /= n;

  // 2. Center data
  const centered = data.map((v) => [
    v[0] - mean[0],
    v[1] - mean[1],
    v[2] - mean[2],
  ]);

  // 3. Compute covariance matrix (3x3)
  let cov = [
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
  ];
  for (let i = 0; i < n; i++) {
    const cx = centered[i][0];
    const cy = centered[i][1];
    const cz = centered[i][2];
    cov[0][0] += cx * cx;
    cov[0][1] += cx * cy;
    cov[0][2] += cx * cz;
    cov[1][0] += cy * cx;
    cov[1][1] += cy * cy;
    cov[1][2] += cy * cz;
    cov[2][0] += cz * cx;
    cov[2][1] += cz * cy;
    cov[2][2] += cz * cz;
  }
  const factor = 1.0 / (n - 1);
  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 3; j++) {
      cov[i][j] *= factor;
    }
  }

  // 4. Eigen decomposition using numeric.js (symmetric matrix)
  const eig = numeric.eig(cov);
  // eigenvalues (real parts)
  let eigenvalues = eig.lambda.x; // array of length 3
  // eigenvectors stored as columns in E (matrix 3x3)
  const E = eig.E.x; // 3x3 matrix where column j is eigenvector for lambda[j]

  // Combine and sort by eigenvalue descending
  let eigenPairs = [];
  for (let i = 0; i < 3; i++) {
    const vec = new THREE.Vector3(E[0][i], E[1][i], E[2][i]).normalize();
    eigenPairs.push({ val: eigenvalues[i], vec: vec, idx: i });
  }
  eigenPairs.sort((a, b) => b.val - a.val);

  const sortedEigenvalues = eigenPairs.map((p) => p.val);
  const sortedEigenvectors = eigenPairs.map((p) => p.vec);

  // Compute explained variance percentages
  const totalVar = sortedEigenvalues.reduce((a, b) => a + b, 0);
  const explainedVars = sortedEigenvalues.map((v) =>
    ((v / totalVar) * 100).toFixed(1),
  );

  console.log(`PC1: ${sortedEigenvalues[0].toFixed(3)}`);
  console.log(`PC2: ${sortedEigenvalues[1].toFixed(3)}`);
  console.log(`PC3: ${sortedEigenvalues[2].toFixed(3)}`);
  console.log(
    `Explained variance: ${explainedVars[0]}% / ${explainedVars[1]}% / ${explainedVars[2]}%`,
  );
  console.log("PCA computed:", sortedEigenvalues, sortedEigenvectors);

  return { mean, sortedEigenvalues, sortedEigenvectors };
}

function drawPcaObj(pcaObj, scene) {
  if (!scene || !pcaObj) return;
  // --- Principal Components as Arrows (scaled by 2 * sqrt(eigenvalue) to show spread) ---
  // Colors: PC1: Red, PC2: Green, PC3: Blue
  const pcColors = [0xff3366, 0x33ff66, 0x33aaff];
  const scaleFactor = 2.2; // multiply by sqrt(eigenvalue) to represent 2.2 standard deviations

  // Store arrows for potential updates (none, just add)
  pcaObj.sortedEigenvectors.forEach((eigenVec, idx) => {
    const lambda = pcaObj.sortedEigenvalues[idx];
    const length = Math.abs(lambda); //Math.sqrt(Math.abs(lambda)) * scaleFactor;
    // Ensure direction is normalized
    const dir = eigenVec.clone().normalize();
    const origin = new THREE.Vector3(
      pcaObj.mean[0],
      pcaObj.mean[1],
      pcaObj.mean[2],
    );
    // ArrowHelper: (origin, dir, length, hex, headLength, headWidth)
    // To make arrows more visible, adjust head proportions
    const arrow = new THREE.ArrowHelper(
      dir,
      origin,
      length,
      pcColors[idx],
      0.15,
      0.1,
    );
    scene.add(arrow);

    // Also add a thin line opposite direction for better visual symmetry (dashed, same color but faint)
    const oppositeDir = dir.clone().negate();
    const oppositeLength = length * 0.85; // slightly shorter to avoid overcluttering
    const dashedLinePoints = [
      origin.clone().add(oppositeDir.clone().multiplyScalar(oppositeLength)),
      origin,
    ];
    const lineGeometry = new THREE.BufferGeometry().setFromPoints(
      dashedLinePoints,
    );
    const lineMaterial = new THREE.LineBasicMaterial({
      color: pcColors[idx],
      transparent: true,
      opacity: 0.4,
    });
    const oppositeLine = new THREE.Line(lineGeometry, lineMaterial);
    scene.add(oppositeLine);
  });
}

export { createPca, drawPointsArray, getPcaObj, drawPcaObj };
